import { render } from "./StudentSessionsManagement.vue?vue&type=template&id=786daec4&scoped=true"
import script from "./StudentSessionsManagement.vue?vue&type=script&lang=js"
export * from "./StudentSessionsManagement.vue?vue&type=script&lang=js"

import "./StudentSessionsManagement.vue?vue&type=style&index=0&id=786daec4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786daec4"]])

export default __exports__